// extracted by mini-css-extract-plugin
export default {"card":"Card_card__ILhJu","hover":"Card_hover__edHB6"};